import i18next from 'i18next';
import en from './en.json';
import ru from './ru.json';

// Keep <html lang> in sync with the UI language (index.html ships lang="en").
// Browsers (Safari, Chrome, Yandex) offer to translate a page whose lang does
// not match its text; their translation rewrites the DOM under React's feet.
// Registered before init so the initial language is applied as well.
i18next.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  resources: {
    en: {
      common: en,
    },
    ru: {
      common: ru,
    },
  },
});

export default i18next;
